import { BaseRes } from 'bff/models/base/baseRes';
import { Pagination } from 'bff/models/base/pagination';
import { FireDetail, InquiryFilter, PolicyQuery, TravelDetail, VehicleDetail, PolicyCheckRenewalReq, PolicyCheckRenewalRes, PetDetail } from 'bff/models/member';
import { ReturnCode } from 'constants/enums/returnCode.enum';
import commonService from 'utils/commonService';
import apiService from './apiService';
import { CodeClass } from 'constants/enums/codeClass.enum';
import { Codes } from 'bff/models/info';

/**
 * @description 頁面初始設定資料方法
 */
const fetchInitSetting = async (lng?: string) => {
  let baseReq = commonService.getApiReqData();
  if (lng) {
    baseReq = commonService.getApiReqData({ LOCALE: lng });
  }
  const reqConfig = commonService.getReqConfig();

  const result = await Promise.all([
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.POLICY_QUERY),
    apiService.fetchCodes(baseReq, reqConfig, CodeClass.UI)
  ]).then(([codeTablesRes, UICodeRes]) => {
    const codeTablesBaseRes:BaseRes<Codes> = { ...codeTablesRes };
    const UICodeBaseRes: BaseRes<Codes> = { ...UICodeRes };
    const res = {
      codeTables: commonService.arrayTypeReturn(codeTablesBaseRes.TRANRS.CODES),
      UICodes: commonService.arrayTypeReturn(UICodeBaseRes.TRANRS.CODES)
    };
    return res;
  });

  return result;
};

/**
 * @description 取得可用查詢條件
*/
const fetchInquiryFilter = async (qClass: string, qID?: string) => {
  const baseReq = commonService.getApiReqData({
    QCLASS: qClass,
    QID: qID
  });

  const config = commonService.getReqConfig();

  const res = await apiService.fetchInquiryFilter(baseReq, config).then((res: BaseRes<InquiryFilter>) => res);

  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE);
  } else {
    return res.TRANRS.FIELDS;
  }
};

/**
 * @description 查詢會員的所有保單列表
*/
const policyQuery = async (req: any, paginationReq: Pagination) => {
  const baseReq = commonService.getApiReqData(req, paginationReq);
  const config = commonService.getReqConfig();
  // console.log(' policyQuery baseReq', baseReq);
  const res = await apiService.policyQuery(baseReq, config).then((res: BaseRes<PolicyQuery>) => res);
  // console.log('res', res);

  if (res.MWHEADER.RETURNCODE === ReturnCode.CodeSuccess) {
    return res.TRANRS;
  }
};

/**
 * @description 會員明細查詢
*/
const inquiryMemberDetail = async (insTypeId: string, req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.inquiryMemberDetail(baseReq, reqConfig).then((res: BaseRes<TravelDetail>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '無法取得明細資料');
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 旅遊險-明細查詢
*/
const inquiryTravelDetail = async (insTypeId: string, req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.inquiryTravelDetail(baseReq, reqConfig, insTypeId).then((res: BaseRes<TravelDetail>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '無法取得明細資料');
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 汽機車險-明細查詢
*/
const inquiryVehicleDetail = async (insTypeId: string, req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.inquiryVehicleDetail(baseReq, reqConfig).then((res: BaseRes<VehicleDetail>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '無法取得明細資料');
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 住火險-明細查詢
*/
const inquiryFireDetail = async (insTypeId: string, req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res = await apiService.inquiryFireDetail(baseReq, reqConfig).then((res: BaseRes<FireDetail>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '無法取得明細資料');
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 寵物險-明細查詢
*/
const inquiryPetDetail = async (req: any) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();
  const res = await apiService.inquiryMemberDetail(baseReq, reqConfig).then((res: BaseRes<PetDetail>) => res);
  if (res.MWHEADER.RETURNCODE !== ReturnCode.CodeSuccess) {
    commonService.showErrorModal(res.MWHEADER.RETURNDESC, res.MWHEADER.RETURNCODE, '無法取得明細資料');
  } else {
    return res.TRANRS;
  }
};

/**
 * @description 各險種 (除旅平險) 檢查保單續保資料
 */
const memberPolicyCheckRenewal = async (req: PolicyCheckRenewalReq, insTypeId: string) => {
  const baseReq = commonService.getApiReqData(req);
  const reqConfig = commonService.getReqConfig();

  const res: BaseRes<PolicyCheckRenewalRes> = await apiService.memberPolicyCheckRenewal(baseReq, reqConfig, insTypeId);
  if (res.MWHEADER.RETURNCODE === ReturnCode.CodeSuccess) {
    return res.TRANRS;
  }
};

export default {
  fetchInitSetting,
  fetchInquiryFilter,
  policyQuery,
  inquiryMemberDetail,
  inquiryTravelDetail,
  inquiryVehicleDetail,
  inquiryFireDetail,
  inquiryPetDetail,
  memberPolicyCheckRenewal
};
